const getSettlementDetails = (uuid, settlemets) => settlemets.find(({ uuid: settlementUuid }) => settlementUuid === uuid);

export { getSettlementDetails };
